import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class DiscountCalViewModel {
    ShowAlert:            (pTitle: string, pMessage: string) => void;
    BackToSignIn:         ()                                 => void;
    NewLoading:           (pMessage: string)                 => dmLoading;
    DetectWidth:          ()                                 => number;
    RegisterResize:       (pAction: () => void)              => void;
    ShowCalendar:         (
         pToday:  Date
        ,pCDay:   Date
        ,pTitle:  string
        ,pLangID: number
        ,pAction: (pCDay: Date)                             => void
    )                                                       => void;

    mlText:               MLText;
    app:                  mlBroker;
    ml:                   mlBroker;
    Hotel:                dmHotel;
    LangID:               number;

    InRefresh:            boolean;
    NumDays:              number;

    OfferTypes:           RQService.Pms.GetOfferTypeMemberDiscountsRow[];
    DiscountDays:         RQService.Pms.GetOfferTypeMemberDiscountWindowRow[];

    SelectOfferTypeTitle: string;

    SelectedOfferTypeID:  number;
    Today:                Date;
    StartDate:            Date;
    StartDateDisplay:     string;
    StartDateModified:    boolean;
    CalHasTwoMonths:      boolean;
    FirstMonthLabel:      string;
    SecondMonthLabel:     string;

    DisplayDays:          RQService.Pms.GetOfferTypeMemberDiscountWindowRow[];

    constructor(
         pMLText:         MLText
        ,pHotel:          dmHotel
        ,pBackToSignIn:   ()                                 => void
        ,pShowAlert:      (pTitle: string, pMessage: string) => void
        ,pNewLoading:     (pMessage: string)                 => dmLoading
        ,pDetectWidth:    ()                                 => number
        ,pRegisterResize: (pAction: () => void)              => void
        ,pShowCalendar:   (
             pToday:  Date
            ,pCDay:   Date
            ,pTitle:  string
            ,pLangID: number
            ,pAction: (pCDay: Date) => void
        )                                                  => void
    ) {
        this.mlText               = pMLText;
        this.LangID               = this.mlText.GetLangID();
        this.app                  = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                   = this.mlText.GetBroker(
            'HotelAreaDiscountCal'
        );

        this.Hotel                = pHotel;
        this.BackToSignIn         = pBackToSignIn;
        this.ShowAlert            = pShowAlert;
        this.NewLoading           = pNewLoading;
        this.DetectWidth          = pDetectWidth;
        this.RegisterResize       = pRegisterResize;
        this.ShowCalendar         = pShowCalendar;

        this.InRefresh            = false;

        this.OfferTypes           = [];
        this.DiscountDays         = [];

        this.SelectedOfferTypeID  = 0;
        this.StartDateModified    = false;

        this.DisplayDays          = [];

        this.SelectOfferTypeTitle = this.ml.Text(
             'ChooseRatePackage'
            ,'Choose Rate Package'
        );

        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        this.NumDays = this.numDaysFromWidth(this.DetectWidth());

        this.RegisterResize(() => {
            this.refreshNumDays(this.numDaysFromWidth(this.DetectWidth()));
        });

        this.InRefresh = true;

        loading.Show(() => {
            this.refreshDiscountDays(() => { this.InRefresh = false; loading.Dismiss(); });
        });
    }

    private numDaysFromWidth(pWidth: number): number {
        let numDays: number = 0;

        if (pWidth < 768) {
            numDays = Math.floor((pWidth - 130) / 50);
        } else {
            numDays = Math.floor((pWidth - 440) / 50);
        }

        if (numDays < 4)  { numDays = 4;  }
        if (numDays > 30) { numDays = 30; }

        return numDays;
    }

    private refreshNumDays(pNumDays: number): void {
        this.NumDays = pNumDays;

        if (this.NumDays > 30) { this.NumDays = 30 }

        this.DisplayDays.length = 0;

        let date_idx: Date = new Date(
             this.StartDate.getFullYear()
            ,this.StartDate.getMonth()
            ,this.StartDate.getDate()
        );

        for (let i = 0; i < this.NumDays; i++) {
            let day:        RQService.Pms.GetOfferTypeMemberDiscountWindowRow = null;
            let dayInCache: boolean                                           = false;

            for (let i = 0; i < this.DiscountDays.length; i++) {
                let resDay: Date = new Date(
                     Number(this.DiscountDays[i].ResDay.substr(0, 4))
                    ,Number(this.DiscountDays[i].ResDay.substr(5, 2)) - 1
                    ,Number(this.DiscountDays[i].ResDay.substr(8, 2))
                );

                if (resDay.valueOf() == date_idx.valueOf()) {
                    day        = this.DiscountDays[i]
                    dayInCache = true;

                    break;
                }
            }

            if (!dayInCache) {
                day = RQService.Pms.PopulateGetOfferTypeMemberDiscountWindowRow({ });

                this.initNonCacheDay(day, date_idx);
            }

            this.DisplayDays.push(day);

            date_idx.setDate(date_idx.getDate() + 1);
        }

        this.updateDateDisplay();
    }

    private initNonCacheDay(
         pNonCacheDay: RQService.Pms.GetOfferTypeMemberDiscountWindowRow
        ,pCDay:        Date
    ): void {
        pNonCacheDay.ResDay  = RQApp.JSDateToRQString(pCDay, false);
        pNonCacheDay.Blocked = -1;
    }

    private refreshDiscountDays(pAction: () => void): void {
        this.updateNotionOfToday();
        this.updateDateDisplay();

        let discountParams = RQParam.PmsGetOfferTypeMemberDiscountsParams();

        discountParams.HotelID = this.Hotel.HotelID;
        discountParams.LangID  = this.Hotel.LangID;

        RQService.Pms.GetOfferTypeMemberDiscounts(discountParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { pAction(); return; }
            
            let offerTypes = response.RQueryResult;

            this.OfferTypes.length = 0;
            
            for (let i = 0; i < offerTypes.length; i++) {
                let offerType = RQService.Pms.PopulateGetOfferTypeMemberDiscountsRow(
                    offerTypes[i]
                );
            
                console.log('ot row push');

                this.OfferTypes.push(offerType);
            }

            if (this.SelectedOfferTypeID == 0) {
                this.SelectedOfferTypeID = this.OfferTypes[0].OfferTypeID;
            }

            let dayParams = RQParam.PmsGetOfferTypeMemberDiscountWindowParams();

            dayParams.HotelID     = this.Hotel.HotelID;
            dayParams.OfferTypeID = this.SelectedOfferTypeID;
            dayParams.StartDate   = RQApp.JSDateToRQString(this.StartDate ,false);

            RQService.Pms.GetOfferTypeMemberDiscountWindow(dayParams).then((result) => {
                let response = result as any;
                
                if (response.HasErrorOrException) { pAction(); return; }
                
                let days = response.RQueryResult;

                this.DiscountDays.length = 0;

                for (let i = 0; i < days.length; i++) {
                    let day = RQService.Pms.PopulateGetOfferTypeMemberDiscountWindowRow(
                        days[i]
                    );

                    console.log('day row push');

                    this.DiscountDays.push(day);
                }

                this.DisplayDays.length = 0;

                let date_idx: Date = new Date(
                     this.StartDate.getFullYear()
                    ,this.StartDate.getMonth()
                    ,this.StartDate.getDate()
                );

                for (let i = 0; i < this.NumDays; i++) {
                    let day:        RQService.Pms.GetOfferTypeMemberDiscountWindowRow = null;
                    let dayInCache: boolean                                           = false;

                    for (let i = 0; i < this.DiscountDays.length; i++) {
                        let resDay: Date = new Date(
                             Number(this.DiscountDays[i].ResDay.substr(0, 4))
                            ,Number(this.DiscountDays[i].ResDay.substr(5, 2)) - 1
                            ,Number(this.DiscountDays[i].ResDay.substr(8, 2))
                        );

                        if (resDay.valueOf() == date_idx.valueOf()) {
                            day        = this.DiscountDays[i]
                            dayInCache = true;

                            break;
                        }
                    }

                    if (!dayInCache) {
                        day = RQService.Pms.PopulateGetOfferTypeMemberDiscountWindowRow({ });

                        this.initNonCacheDay(day, date_idx);
                    }

                    this.DisplayDays.push(day);

                    date_idx.setDate(date_idx.getDate() + 1);
                }

                pAction();
            });
        });
    }

    private updateNotionOfToday(): void {
        let now    = new Date();
        
        this.Today = new Date(
             now.getFullYear()
            ,now.getMonth()
            ,now.getDate()
        );

        if (!this.StartDateModified) {
            this.StartDate        = new Date(
                 this.Today.getFullYear()
                ,this.Today.getMonth()
                ,this.Today.getDate()
            );

            this.StartDateDisplay = RQApp.JSDateToRQString(this.StartDate, false);
        }
    }

    private updateDateDisplay() {
        this.StartDateDisplay = RQApp.JSDateToRQString(this.StartDate, false);

        this.FirstMonthLabel  = this.StartDate.toLocaleString(
             RQApp.LangCodesByID[this.LangID]
            ,{ month: 'long' }
        ) + ' ' + this.StartDate.getFullYear().toString();

        let endDate: Date = new Date(
             this.StartDate.getFullYear()
            ,this.StartDate.getMonth()
            ,this.StartDate.getDate()
        );

        endDate.setDate(endDate.getDate() + (this.NumDays - 1));

        if (this.StartDate.getMonth() == endDate.getMonth()) {
            this.CalHasTwoMonths  = false;
            this.SecondMonthLabel = '';
        } else {
            this.CalHasTwoMonths  = true;
            this.SecondMonthLabel = endDate.toLocaleString(
                 RQApp.LangCodesByID[this.LangID]
                ,{ month: 'long' }
            ) + ' ' + this.StartDate.getFullYear().toString();
        }
    }

    public SelectOfferType(event: any) {
        if (this.InRefresh) { return; }

        let offerTypeID = event as number;

        this.SelectedOfferTypeID = offerTypeID;

        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshDiscountDays(() => { loading.Dismiss(); });
        });
    }

    public ToggleDayBlockState(
         pResDay:     string
        ,pBlocked:    boolean
        ,pNotInCache: boolean
    ): void {
        if (this.InRefresh || pNotInCache) { return; }

        let blockParams = RQParam.PmsSetOfferTypeMemberDiscountDaysParams();

        blockParams.HotelID     = this.Hotel.HotelID;
        blockParams.OfferTypeID = this.SelectedOfferTypeID;
        blockParams.StartDate   = pResDay;
        blockParams.EndDate     = pResDay;
        blockParams.Blocked     = (pBlocked) ? 1 : 0;

        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            RQService.Pms.SetOfferTypeMemberDiscountDays(blockParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                this.refreshDiscountDays(() => { loading.Dismiss(); });
            });
        });
    }

    public ChangeCalDate(pStartDate: Date): void {
        if (this.InRefresh)                                    { return; }
        if (this.StartDate.getTime() === pStartDate.getTime()) { return; }

        this.StartDateModified = true;

        this.StartDate         = pStartDate;

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshDiscountDays(() => {
                loading.Dismiss();

                return;
            });
        });
    }

    public CalDateNext() {
        if (this.InRefresh) { return; }

        this.StartDateModified = true;

        this.StartDate.setDate(this.StartDate.getDate() + (this.NumDays - 1));

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshDiscountDays(() => {
                loading.Dismiss();

                return;
            });
        });
    }

    public CalDatePrev() {
        if (this.InRefresh) { return; }

        this.StartDateModified = true;

        this.StartDate.setDate(this.StartDate.getDate() - (this.NumDays - 1));

        if (this.StartDate <= this.Today) {
            this.StartDate = new Date(
                 this.Today.getFullYear()
                ,this.Today.getMonth()
                ,this.Today.getDate()
            );
        }

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshDiscountDays(() => {
                loading.Dismiss();

                return;
            });
        });
    }

    public ShowDateSelector(): void {
        if (this.InRefresh) { return; }

        this.updateNotionOfToday();

        this.ShowCalendar(
             this.Today
            ,this.StartDate
            ,this.ml.Text('ChooseRatePeriodStart' ,'Choose Rate Period Start')
            ,this.LangID
            ,(pStartDate: Date) => { this.ChangeCalDate(pStartDate); }
        );
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/discount-cal/xv-discount-cal.ts